import { LoadingAnimation, Modal } from '@uag/react-core';
import { StepActionType, StepModel, StepProgress } from '@uag/welcome-shared/src/api/models';
import { useGetRequestDetail } from '@uag/welcome-shared/src/api/queries/requests/requests';
import { CompanyForm } from '@uag/welcome-shared/src/components/company/CompanyForm/CompanyForm';
import { useTranslation } from 'react-i18next';
import { create, InstanceProps } from 'react-modal-promise';
import { useParams } from 'react-router';

type Props = {
    open: boolean;
    stepActionType: StepActionType;
    stepProgress: StepProgress;
    step: StepModel;
    onClose: () => void;
} & InstanceProps<void>;

export const EditCompanyModal = ({ isOpen, onResolve, onReject }: Props) => {
    const { t } = useTranslation();
    const { requestId = '' } = useParams();
    const { data: apiRequestDetail, isLoading: isRequestDetailLoading } = useGetRequestDetail(requestId, {});

    const requestDetail = apiRequestDetail?.data;

    const submit = () => onResolve();
    const reject = () => onReject();

    if (!requestDetail) {
        return null;
    }

    return (
        <Modal className="w-[960px]" opened={isOpen} title={t('insertCompanyData')} onAbort={reject} onClose={reject}>
            {isRequestDetailLoading && <LoadingAnimation />}
            {requestDetail && <CompanyForm request={requestDetail} onClose={submit} />}
        </Modal>
    );
};

export const openEditCompanyModal = create(EditCompanyModal);
